import { MANAGING_MONITORING_PRICING_LEVEL, MANAGING_MONITORING_PRICING_LEVEL_TITLE } from '@app/api/constants'

import { LntSelectOption } from '@app/components/base/Select/types'

import type { ClassifierControlsColumn } from './types'

export const columnTitleMap: Record<keyof ClassifierControlsColumn, string> = {
  id: 'Код вида',
  name: 'Название вида',
  categoryId: 'Категория'
}

// TODO: добавить константу
export const categoryOptions = Object.values(MANAGING_MONITORING_PRICING_LEVEL).map<LntSelectOption>(
  categoryOptions => {
    return {
      label: MANAGING_MONITORING_PRICING_LEVEL_TITLE[categoryOptions],
      value: MANAGING_MONITORING_PRICING_LEVEL_TITLE[categoryOptions]
    }
  }
)
